import { render, staticRenderFns } from "./SetupMfaDialog.vue?vue&type=template&id=0b91f377&scoped=true&"
import script from "./SetupMfaDialog.vue?vue&type=script&lang=js&"
export * from "./SetupMfaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b91f377",
  null
  
)

export default component.exports